export default class Buttons {
	static init() {

		document.querySelectorAll(".btn-fill").forEach((button) => {
			if (button.querySelector(".dots")) {
				return;
			}
			const text = `<span class="dots"></span><span class="label">${button.innerHTML}</span>`;
			button.innerHTML = text;
		});

		document.querySelectorAll(".btn-arrow").forEach((button) => {
			const text = `<span class="arrow"></span>`;
			button.innerHTML = text;
		});
	}
}
